import uec2026ExamSchedulePdf from "../../../assets/dashboard/UEC 2026 Exam Schedule - Updated 29 Jun 2026.pdf";
import uec2026chinese from "../../../assets/dashboard/UEC2026/0921 (课后材料)高中华文.pdf";
import uec2026math from "../../../assets/dashboard/UEC2026/0922 高中数学_高级数学_无理方程式.pdf";
import uec2026bio from "../../../assets/dashboard/UEC2026/0924 高中生物笔记.pdf";
import uec2026chem from "../../../assets/dashboard/UEC2026/0925 高中化学笔记.pdf";
import uec2026phy from "../../../assets/dashboard/UEC2026/0928 高中物理笔记.pdf";
import uec2026acc from "../../../assets/dashboard/UEC2026/0929 会计学.pdf";
import uec2026eng from "../../../assets/dashboard/UEC2026/0930 高中英文笔记.pdf";
import uec2026addmath from "../../../assets/dashboard/UEC2026/1001 独中统考2017高中组(高级数学I) (2).pdf";
import { SUBJECT_ICONS, TEACHERS } from "../../LandingPage/UEC2026Data";

const getSubjectColor = (id: string) =>
  TEACHERS.find((teacher) => teacher.id === id)?.color ?? "#64748B";

const getSubjectIcon = (name: string) => SUBJECT_ICONS[name] ?? "";

export const UEC_NOTES = [
  {
    id: `uec_schedule`,
    subject: "UEC Exam Schedule",
    title: `UEC Exam Schedule`,
    description: "Exam Schedule for UEC 2026",
    type: "schedule",
    size: "pdf",
    uploadedAt: "29 June 2026",
    downloadUrl: uec2026ExamSchedulePdf,
    subjectColor: "#c10007",
    subjectEmoji: "📅",
  },
  {
    id: `uec_note_chinese`,
    subject: "高中华文",
    title: `高中华文 Revision Notes`,
    description: "UEC高中华文课后复习材料，帮助学生巩固课堂重点并加强备考练习",
    type: "notes",
    size: "pdf",
    uploadedAt: "22 Sept 2026",
    downloadUrl: uec2026chinese,
    subjectColor: getSubjectColor("uec_teacher_cn"),
    subjectEmoji: getSubjectIcon("高中华文"),
  },
  {
    id: `uec_note_math`,
    subject: "高中数学",
    title: `高中数学 Revision Notes`,
    description:
      "高中数学与高级数学复习材料，重点讲解无理方程式的解法与相关练习。",
    type: "notes",
    size: "pdf",
    uploadedAt: "22 Sept 2026",
    downloadUrl: uec2026math,
    subjectColor: getSubjectColor("uec_teacher_math"),
    subjectEmoji: getSubjectIcon("高中数学"),
  },
  {
    id: `uec_note_biology`,
    subject: "高中生物",
    title: `高中生物 Revision Notes`,
    description:
      "Class notes and learning materials will be uploaded here when available.",
    type: "notes",
    size: "pdf",
    uploadedAt: "6 Oct 2026",
    downloadUrl: uec2026bio,
    subjectColor: getSubjectColor("uec_teacher_bio"),
    subjectEmoji: getSubjectIcon("高中生物"),
  },
  {
    id: `uec_note_chemistry`,
    subject: "高中化学",
    title: `高中化学 Revision Notes`,
    description:
      "Class notes and learning materials will be uploaded here when available.",
    type: "notes",
    size: "pdf",
    uploadedAt: "6 Oct 2026",
    downloadUrl: uec2026chem,
    subjectColor: getSubjectColor("uec_teacher_chem"),
    subjectEmoji: getSubjectIcon("高中化学"),
  },
  {
    id: `uec_note_physics`,
    subject: "高中物理",
    title: `高中物理 Revision Notes`,
    description:
      "Class notes and learning materials will be uploaded here when available.",
    type: "notes",
    size: "pdf",
    uploadedAt: "6 Oct 2026",
    downloadUrl: uec2026phy,
    subjectColor: getSubjectColor("uec_teacher_phy"),
    subjectEmoji: getSubjectIcon("高中物理"),
  },
  {
    id: `uec_note_accounting`,
    subject: "高中会计学",
    title: `高中会计学 Revision Notes`,
    description: "UEC 会计学复习材料，帮助学生掌握核心概念并巩固答题技巧。",
    type: "notes",
    size: "pdf",
    uploadedAt: "22 Sept 2026",
    downloadUrl: uec2026acc,
    subjectColor: getSubjectColor("uec_teacher_acc"),
    subjectEmoji: getSubjectIcon("高中会计学"),
  },
  {
    id: `uec_note_english`,
    subject: "高中英文",
    title: `高中英文 Revision Notes`,
    description:
      "Class notes and learning materials will be uploaded here when available.",
    type: "notes",
    size: "pdf",
    uploadedAt: "6 Oct 2026",
    downloadUrl: uec2026eng,
    subjectColor: getSubjectColor("uec_teacher_en"),
    subjectEmoji: getSubjectIcon("高中英文"),
  },
  {
    id: `uec_note_addmath`,
    subject: "高级数学",
    title: `高级数学 Revision Notes`,
    description: "2017 年 UEC 高级数学 I 试题练习，适合考前演练与题型复习。",
    type: "notes",
    size: "pdf",
    uploadedAt: "22 Sept 2026",
    downloadUrl: uec2026addmath,
    subjectColor: getSubjectColor("uec_teacher_add_math"),
    subjectEmoji: getSubjectIcon("高级数学"),
  },
];

// export const UEC_SCHEDULE = [
//   {
//     id: "uec_session_cn",
//     subject: "高中华文",
//     topic: "高中华文 Revision Notes",
//     teacherId: "uec_teacher_cn",
//     date: "21 Sept 2026",
//     day: "星期一",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/86798724123?pwd=Kb2MOOBAR0auagFaodtbcS1cXobsLq.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_cn"),
//     subjectEmoji: getSubjectIcon("高中华文"),
//   },
//   {
//     id: "uec_session_math",
//     subject: "高中数学",
//     topic: "高中数学 Revision Notes",
//     teacherId: "uec_teacher_math",
//     date: "22 Sept 2026",
//     day: "星期二",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/86855877495?pwd=jqSoWkaUswxYbYkyIPDnwyi0ngHaEa.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_math"),
//     subjectEmoji: getSubjectIcon("高中数学"),
//   },
//   {
//     id: "uec_session_bio",
//     subject: "高中生物",
//     topic: "高中生物 Revision Notes",
//     teacherId: "uec_teacher_bio",
//     date: "23 Sept 2026",
//     day: "星期三",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/82815166470?pwd=GCUoyQnjRZyxl4VaUiMemgtHzC6zjw.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_bio"),
//     subjectEmoji: getSubjectIcon("高中生物"),
//   },
//   {
//     id: "uec_session_chem",
//     subject: "高中化学",
//     topic: "高中化学 Revision Notes",
//     teacherId: "uec_teacher_chem",
//     date: "24 Sept 2026",
//     day: "星期四",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/84745723910?pwd=Q9uNteIiifilouURwSxWgxFYfLpoqb.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_chem"),
//     subjectEmoji: getSubjectIcon("高中化学"),
//   },
//   {
//     id: "uec_session_phy",
//     subject: "高中物理",
//     topic: "高中物理 Revision Notes",
//     teacherId: "uec_teacher_phy",
//     date: "25 Sept 2026",
//     day: "星期五",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/81950307073?pwd=81mHhk6gng1duaQzmyioMsr3b6Yxyn.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_phy"),
//     subjectEmoji: getSubjectIcon("高中物理"),
//   },
//   {
//     id: "uec_session_acc",
//     subject: "高中会计学",
//     topic: "高中会计学 Revision Notes",
//     teacherId: "uec_teacher_acc",
//     date: "29 Sept 2026",
//     day: "星期二",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/86391616344?pwd=3khxIwAlYr4mavISXy2cIXwL3I2zDz.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_acc"),
//     subjectEmoji: getSubjectIcon("高中会计学"),
//   },
//   {
//     id: "uec_session_eng",
//     subject: "高中英文",
//     topic: "高中英文 Revision Notes",
//     teacherId: "uec_teacher_eng",
//     date: "30 Sept 2026",
//     day: "星期三",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/83634848632?pwd=5NbbndaClLjAbFztTbuj5aCvsnOA41.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_eng"),
//     subjectEmoji: getSubjectIcon("高中英文"),
//   },
//   {
//     id: "uec_session_add_math",
//     subject: "高级数学",
//     topic: "高级数学 Revision Notes",
//     teacherId: "uec_teacher_add_math",
//     date: "1 Oct 2026",
//     day: "星期四",
//     time: "7.30 PM - 10.00 PM",
//     duration: "2.5 hours",
//     zoomLink:
//       "https://us02web.zoom.us/j/89730418527?pwd=yauY7WPzfgO74UHykvAbEelYz4SGXK.1",
//     status: "upcoming",
//     subjectColor: getSubjectColor("uec_teacher_add_math"),
//     subjectEmoji: getSubjectIcon("高级数学"),
//   },
// ];

export const UEC_SCHEDULE = [
  {
    id: "uec_session_cn",
    subject: "高中华文",
    topic: "高中华文 Revision Notes",
    teacherId: "uec_teacher_cn",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/5o_YTx6tgEM",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_cn"),
    subjectEmoji: getSubjectIcon("高中华文"),
  },
  {
    id: "uec_session_math",
    subject: "高中数学",
    topic: "高中数学 Revision Notes",
    teacherId: "uec_teacher_math",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/0GxwnOVZ5_I",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_math"),
    subjectEmoji: getSubjectIcon("高中数学"),
  },
  {
    id: "uec_session_bio",
    subject: "高中生物",
    topic: "高中生物 Revision Notes",
    teacherId: "uec_teacher_bio",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/fcYRDbX5CoY",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_bio"),
    subjectEmoji: getSubjectIcon("高中生物"),
  },
  {
    id: "uec_session_chem",
    subject: "高中化学",
    topic: "高中化学 Revision Notes",
    teacherId: "uec_teacher_chem",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/HIwJgrk89RA?si=ImgZ-7cgF0Sjxar8",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_chem"),
    subjectEmoji: getSubjectIcon("高中化学"),
  },
  {
    id: "uec_session_phy",
    subject: "高中物理",
    topic: "高中物理 Revision Notes",
    teacherId: "uec_teacher_phy",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/VnTLLmpQrF0?si=jKt7lMFMHzPOhur0",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_phy"),
    subjectEmoji: getSubjectIcon("高中物理"),
  },
  {
    id: "uec_session_acc",
    subject: "高中会计学",
    topic: "高中会计学 Revision Notes",
    teacherId: "uec_teacher_acc",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/w8cmMEeL6lM",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_acc"),
    subjectEmoji: getSubjectIcon("高中会计学"),
  },
  {
    id: "uec_session_eng",
    subject: "高中英文",
    topic: "高中英文 Revision Notes",
    teacherId: "uec_teacher_eng",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "1.5 hours",
    zoomLink: "https://youtu.be/fErXwORTnBk",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_eng"),
    subjectEmoji: getSubjectIcon("高中英文"),
  },
  {
    id: "uec_session_add_math",
    subject: "高级数学",
    topic: "高级数学 Revision Notes",
    teacherId: "uec_teacher_add_math",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/XXyM6dTaP40",
    status: "recordings",
    subjectColor: getSubjectColor("uec_teacher_add_math"),
    subjectEmoji: getSubjectIcon("高级数学"),
  },
];
